// msalConfig.js
import { PublicClientApplication } from "@azure/msal-browser";
import { ClientID, RedirectURL } from ".";

export const msalConfig = {
  auth: {
    clientId: ClientID, // replace with your app client ID
    redirectUri: RedirectURL,
  },
  cache: {
    cacheLocation: "localStorage", // keeps login across tabs
    storeAuthStateInCookie: true,
  },
};

// MSAL instance shared across app
export const msalInstance = new PublicClientApplication(msalConfig);

// Delegated scopes for event creation + attendance report
export const loginRequest = {
  scopes: [
    "User.Read",
    "OnlineMeetings.ReadWrite",
    "OnlineMeetingArtifact.Read.All"
  ],
};

// Helper to get access token
export const getAccessToken = async () => {
  let accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    // first-time login popup
    const loginResponse = await msalInstance.loginPopup(loginRequest);

    accounts = msalInstance.getAllAccounts();
    // return loginResponse.accessToken;
     return {
      accessToken: loginResponse.accessToken,
      username: loginResponse.account.username,
    };
  }

  try {

    // Try silent token first
    const silentResult = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    // return silentResult.accessToken;
    return {
      accessToken: silentResult.accessToken,
      username: accounts[0].username,
    };
  } catch {
    // fallback popup if silent fails (new scopes or consent required)
    const popupResult = await msalInstance.acquireTokenPopup(loginRequest);

    // return popupResult.accessToken;
     return {
      accessToken: popupResult.accessToken,
      username: popupResult.account.username,
    };

  }
};
